import request from '@/utils/request';

/*在线咨询-申请*/
export function saveConsult(json) {
  return request({
    url: '/consult',
    method: 'post',
    data: json,
  })
}

/*在线咨询-历史列表*/
export function getHistoryConsultList(parameter) {
  return request({
    url: '/consult',
    method: 'get',
    params: parameter,
  })
}

export function getHistoryConsultLists(parameter) {
  return request({
    url: '/consults',
    method: 'get',
    params: parameter,
  })
}

/*在线咨询-详情*/
export function getOneConsultDetail(parameter) {
  return request({
    url: '/consult/'+parameter.id,
    method: 'get',
  })
}
